export default __webpack_public_path__ + "media/landscape/logo_mrporter-9f94723a.svg";